import {
  OrientationType,
  type ProfileLayoutScreenModel,
  Resolution,
  ScreenType,
} from "@package/ui-gql/index-data-access";
import {
  SCREEN_DIMENSIONS_BY_RESOLUTION_ORIENTATION,
  type ScreenDimension,
} from "../constants/constants";

export function getScreenDimensions(
  type?: ScreenType,
  profileScreen?: ProfileLayoutScreenModel,
): ScreenDimension {
  switch (type) {
    case ScreenType.Custom:
      if (profileScreen?.size?.height && profileScreen?.size?.width) {
        return {
          height: profileScreen?.size?.height,
          width: profileScreen?.size?.width,
        };
      }
      break;
    case ScreenType.Tv:
      if (profileScreen?.resolution && profileScreen?.orientation) {
        return SCREEN_DIMENSIONS_BY_RESOLUTION_ORIENTATION[
          profileScreen.resolution
        ][profileScreen.orientation];
      }
      break;
    default:
      break;
  }

  return SCREEN_DIMENSIONS_BY_RESOLUTION_ORIENTATION[Resolution.Fhd][
    OrientationType.Portrait
  ];
}

export function getWallDimensions(
  type?: ScreenType,
  profileScreen?: ProfileLayoutScreenModel,
): ScreenDimension {
  const screen = getScreenDimensions(type, profileScreen);

  switch (type) {
    case ScreenType.Custom:
      break;
    case ScreenType.Tv:
      if (profileScreen?.columns && profileScreen?.rows) {
        return {
          height: screen.height * profileScreen.rows,
          width: screen.width * profileScreen.columns,
        };
      }
      break;
    default:
      break;
  }

  return screen;
}
